/*
  Channel types 0, 7, and 8 are used by merchants that don't have traditional
  waitstaff (e.g. TTP merchants), so they get a merchant-branded "contact staff"
  message instead of the default "ask the waitstaff" copy.
*/
const CONTACT_STAFF_CHANNEL_TYPE_IDS = ['0', '7', '8'];

function returnStaffAssistanceCopy(merchant, channelTypeId) {
  if (merchant && channelTypeId != null && CONTACT_STAFF_CHANNEL_TYPE_IDS.includes(String(channelTypeId))) {
    return `Please contact ${merchant.name} staff for assistance.`;
  }

  return 'Please ask the waitstaff for assistance.';
}



export default returnStaffAssistanceCopy;
